import React from 'react';
import { connect } from 'react-redux';
import Form from '../../../components/form/form';
import Message from '../../../components/message/index';
import Breadcrumb from '../../../components/breadcrumb/index';
import moment from 'moment';
import { errorCodeByMsisdnReport, exportOmsgReport, virtualNumberList } from '../../../actions/actions';
import { scrollToTop } from '../../../actions/utils';
import Select from '../../../components/form/select';

class ErrorCodeMsisdnReport extends React.Component {
    constructor(props)
    {
        super(props)
        this.reportRef = React.createRef();

        this.state = {
            itemDetailsToShow: [],
            list: [],
            pageSize: 0,
            pageNumber: 0,
            totalItemCount: 0,
            downloadOptions: {
                value: 'PDF',
                name: 'downloadOptions',
                type: 'select',
                label: '',
                placeholder: 'Dosya Tipi',
                options: [{name: 'PDF', value: 'pdf'},{name: 'Excel', value: 'xlsx'}],
                error: 'Lütfen dosya tipi seçiniz.',
                valid: true,
                touched: false,
                validationRules: {
                    isRequired: true
                }
            },
            formModel: {
                virtualNumber: {
                    value: '',
                    name: 'virtualNumber',
                    type: 'select',
                    label: 'Sanal Numara',
                    placeholder: 'Sanal Numara',
                    error: 'Lütfen Sanal Numara girin.',
                    options: [],
                    valid: false,
                    touched: false,
                    validationRules: {
                        isRequired: true
                    }
                },
                searchedMsisdn: {
                    value: '',
                    name: 'searchedMsisdn',
                    type: 'phone',
                    label: 'Numara ara',
                    placeholder: 'Numara ara',
                    error: 'Lütfen telefon numarası girin.',
                    valid: true,
                    touched: false,
                    validationRules: {
                        isRequired: true
                    }
                },
                searchStartDate: {
                    value: '',
                    name: 'searchStartDate',
                    type: 'textdate',
                    label: 'Başlangıç Tarihi',
                    error: 'Lütfen başlangıç tarihi seçin.',
                    valid: false,
                    touched: false,
                    isHalf: false,
                    isHalfStart: false,
                    minDate: '',
                    validationRules: {
                        isDate: true,
                        isRequired: true
                    }
                },
                searchEndDate: {
                    value: '',
                    name: 'searchEndDate',
                    type: 'textdate',
                    label: 'Bitiş Tarihi',
                    error: 'Lütfen bitiş tarihi seçin.',
                    valid: false,
                    touched: false,
                    isHalf: false,
                    isHalfStart: false,
                    minDate: '',
                    validationRules: {
                        isDate: true,
                        isRequired: true
                    }
                },
            }
        };

        this.getVirtualNumberList();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(data)
    {
        this.getReport(data);
    }

    getReport(data){
        var foundedObj = this.state.virtualNumberList.find(vm => vm.product.virtualNumber === data.virtualNumber).product;
        foundedObj.tariff = foundedObj.tariffPlan;
        this.props.dispatch(errorCodeByMsisdnReport({...data, ...foundedObj}, (response) => {
            this.setState({
                itemDetailsToShow: [],
                list: response.reportItems,
                pageNumber: response.pageNumber,
            });
        }, (data) => {
            scrollToTop();
        }));
    }

    getVirtualNumberList(){
        this.props.dispatch(virtualNumberList((response) => {
        }, (data) => {
            this.setState({
                virtualNumberList: data,
                formModel: {
                    ...this.state.formModel,
                    virtualNumber: {
                        ...this.state.formModel.virtualNumber,
                        options: data.map(x => ({value:x.product.virtualNumber, name:x.product.virtualNumber}))
                    }
                }
            })
        }));
    }

    downloadReport() {
        if(this.state.downloadOptions.value != '') {
            var foundedObj = this.state.virtualNumberList.find(vm => vm.virtualNumber === this.state.formModel.virtualNumber.value);
            let requestData = {
                type: 'error_code_by_msisdn',
                docType: this.state.downloadOptions.value,
                reportRequest: {
                    searchedMsisdn:this.state.formModel.searchedMsisdn.value,
                    searchStartDate:this.state.formModel.searchStartDate.value.replace('.','').replace('.',''),
                    searchEndDate:this.state.formModel.searchEndDate.value.replace('.','').replace('.',''),
                    pageNumber: this.state.pageNumber,
                    ...foundedObj
                }
            }
            this.props.dispatch(exportOmsgReport(requestData, () => {
            }, () => {
    
            }));
        }
    }

    async changePage(nextPageNumber){
        if(nextPageNumber === -1 && this.state.pageNumber === 0) {

        } else {
            this.getReport({
                searchedMsisdn:this.state.formModel.searchedMsisdn.value, pageNumber: nextPageNumber});
        }
    }

    handleSelectDownloadOption(data){
        if(data.target.value != '') {
            this.setState({downloadOptions: {...this.state.downloadOptions, value: data.target.value}})
        } else{
            this.setState({downloadOptions: {...this.state.downloadOptions, value: data.target.value}})
        }
    }

    render() {
        const breadcrumbItems = [{
            name: "Msisdn Bazlı Hata Rapor"
        }];

        return (
        [
            <Breadcrumb items={breadcrumbItems} />,
            <section className="panel">
                <Message />
                <div className="container">
                    <div className="reports">
                        <div className="title-default">
                            <span>Msisdn Bazlı Hata Rapor</span>
                        </div>
                        <div className="report-form">
                            <Form model={this.state.formModel} handleSubmit={this.handleSubmit} smallTitle={""} buttonText={"Rapor Oluştur"} buttonId={"report-list-filter"} multipleColumn={true} />
                        </div>  
                        {this.state.list.length > 0 && 
                        <div>
                               <div style={{display: 'table', textAlign:'center', width: '100%', margin:'10px 0 10px 0'}}>
                            <div style={{display:'table-cell', width:'50vh', verticalAlign:'middle', paddingRight:'5px'}}>
                            <Select data={this.state.downloadOptions} handleChange={this.handleSelectDownloadOption.bind(this)} />

                            </div>
                            <div style={{display:'table-cell', width:'50vh', paddingLeft:'5px'}}>
                            <a id="report-send-download" className="btn primary" href="javascript:void(0)" title="Tümünü indir" onClick={this.downloadReport.bind(this)}>
                                                    <span>Tümünü indir</span>
                                                </a>
                            </div>
                        </div>
                                <div className="report-items">
                                    <div ref={this.reportRef} className="head custom-report-head error-msisdn-report-head">
                                        <div className="item error-msisdn-report-head">
                                            <div>Sanal Numara</div>
                                            <div>Numara</div>
                                            <div>Gönderim Tarihi</div>
                                            <div>Hata Kodu</div>
                                            <div>Açıklama</div>
                                            <div>Tip</div>
                                        </div>
                                    </div>
                                    <div className="body" style={{marginTop: '0.3rem'}}>
                                        {this.state.list.map((item, i) =>
                                            <div className="item error-msisdn-code-report-item">
                                                <div>
                                                    <span className="label">Sanal Numara</span>
                                                    <span>{item.companyMsisdn}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Numara</span>
                                                    <span>{item.searchedMsisdn}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Gönderim Tarihi</span>
                                                    <span>{item.requestTime != null ? moment(item.requestTime).format('DD.MM.YYYY') : ''}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Hata Kodu</span>
                                                    <span>{item.sisError}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Açıklama</span>
                                                    <span>{item.errorDetail}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Tip</span>
                                                    <span>{item.type}</span>
                                                </div>
                                            </div>
                                            )}
                                    </div>
                                </div>
                          
                        </div>
                          }
                        {this.state.list.length > 0 &&
                            <div className="paging">
                                {this.state.pageNumber !== 0 && <a href="javascript:void(0)" className={"first-item"} onClick={() => this.changePage(-1)}>&lt;&lt;</a>}
                                <a href="javascript:void(0)" className={"last-item"}  onClick={() => this.changePage(+1)}>&gt;&gt;</a>
                            </div>
                        }
                      </div>
                </div>
            </section>
        ]
      );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}


export default connect(mapStateToProps)(ErrorCodeMsisdnReport)